import UserBaseSection from './UserBaseSection';
import UserCollapsableAttributes from '../formFields/UserCollapsableAttributes';
import { useSelector } from 'react-redux';

const UserZoomSection = ({
    submitData,
    setSubmitData,
    errors,
    touched,
    platformUser,
}) => {
    const { darkMode } = useSelector((state) => state.settings);
    const section = 'zoom';
    const platformIndex = submitData.findIndex(
        (platform) => platform.platformID === platformUser?.platformID,
    );

    const fields = [
        <UserBaseSection
            key={`${section}-userBaseSection`}
            submitData={submitData}
            setSubmitData={setSubmitData}
            errors={errors}
            touched={touched}
            platformUser={platformUser}
            section={section}
        />,
        <UserCollapsableAttributes
            key="teams-collapsable-attributes"
            index={5}
            errors={errors}
            touched={touched}
            darkMode={darkMode}
            platformIndex={platformIndex}
            isLastItem={true}
        />,
    ].filter(Boolean);
    return fields;
};

export default UserZoomSection;
